export enum AggregationLevel {
    None = 0,
    Tenant = 1,
    BusinessUnit = 2,
    Queue = 3,
}
